module.exports = __webpack_public_path__ + "shared/static_img/telegram_large.9b8bd097.png";